<template>
  <div class="home" v-if="is_skip">
    <van-nav-bar :title="shopInfos.name" fixed>
      <van-icon
        name="./static/img/boss_shop.png"
        size="30px"
        slot="right"
        @click="$router.push('/ShopInfo/' + sessionStorage.storeId)"
      />
    </van-nav-bar>
    <div style="height: 46px; background: #f3f5f7"></div>
    <div style="border-top: 1px solid #f3f3f3">
      <van-image
        v-if="shopInfos.image"
        width="100%"
        fit="cover"
        :src="shopInfos.image.path"
      />
    </div>
    <div style="text-align: center">{{ $t("MealNum.text") }}</div>
    <div class="numArea">
      <div
        v-for="val in number"
        @click="changeVal(val)"
        class="numItem"
        :class="[value == val ? 'actNum' : '']"
      >
        {{ val }}
      </div>
    </div>
    <div style="height: 100px; background: rgb(255 255 255)"></div>
    <div class="numInput">
      <van-cell :title="$t('MealNum.mealNum')">
        <van-stepper
          solt="right"
          :max="99"
          v-model="value"
          integer
          input-width="60px"
          button-size="30px"
        />
      </van-cell>
    </div>
    <van-tabbar>
      <van-button class="nomBtn" round @click="toChooseSeat()">{{
        $t("MealNum.seat")
      }}</van-button>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: 1,
      number: 12,
      place: {},
      changeLocale: "",
      shopInfos: [],
      is_skip: false, //是否选人数
      is_out: false //是否外卖
    };
  },
  mounted: function() {
    this.judgePlaceStatus();
    sessionStorage.setItem("code", this.$route.params.code);
    sessionStorage.setItem("type", "");
    sessionStorage.setItem("storeId", this.$route.params.storeId);
    sessionStorage.setItem("placeId", this.$route.params.placeId);
    this.getShopLang();
    this.getShopInfo();
  },
  methods: {
    changeVal(value) {
      this.value = value;
      sessionStorage.setItem("mealNum", value);
    },
    toChooseSeat() {
      sessionStorage.setItem("mealNum", this.value);
      this.$router.push("/Dishes");
    },
    judgePlaceStatus() {
      // 获取座位状态
      this.$axios({
        method: "GET",
        url:
          this.$build +
          "/api/place/" +
          this.$route.params.placeId +
          "/customerStatus"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            // this.number=res.data.data.number;
            if (res.data.data.status == 1 && res.data.data.order) {
              this.value = res.data.data.order.sitter;
              sessionStorage.setItem("actOrderId", res.data.data.order.id);
              sessionStorage.setItem("mealNum", res.data.data.order.sitter);
              sessionStorage.setItem("orderType", "add");
              //   this.$router.push("/Dishes");
            } else {
              sessionStorage.setItem("orderType", "new");
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },

    // 获取店铺信息
    getShopInfo() {
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: this.$route.params.code
        },
        url:
          this.$build +
          "/api/store/" +
          this.$route.params.storeId +
          "/customerShow"
      })
        .then(res => {
          console.log(res.data.data);
          if (res.data.status == 200) {
            this.shopInfos = res.data.data;
            sessionStorage.setItem("images", res.data.data.image.path);
            this.is_skip = res.data.data.is_skip == "1" ? true : false;
            this.is_out = res.data.data.is_out == "1" ? true : false;
            console.log(this.is_skip, "是否跳过选人数");
            console.log(this.is_out, "是否外卖");
            if (this.is_out) {
              // 如果外卖
              sessionStorage.setItem("table_out", this.is_out);
              // 走新外卖线路，再原外卖线路上新增判断，不可影响原外卖
              this.$router.push("/TakeDishes");
            } else {
              if (!this.is_skip) {
                // 跳过选位置
                this.$router.push("/Dishes");
              } else {
                console.log("否");
              }
              sessionStorage.setItem("currency", res.data.data.currency.unit);
              sessionStorage.setItem("is_quick", res.data.data.is_quick);
            }
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },

    //获取店铺语言
    getShopLang() {
      this.$axios({
        method: "get",
        url:
          this.$build + "/api/store/" + this.$route.params.storeId + "/language"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            if (res.data.data.id == 2 || res.data.data.name_en == "zh_hk") {
              this.$i18n.locale = "hk";
              sessionStorage.setItem("locale", "hk");
              this.changeLocale = "zh_hk";
            } else if (res.data.data.id == 1 || res.data.data.name_en == "en") {
              this.$i18n.locale = "en";
              sessionStorage.setItem("locale", "en");
              this.changeLocale = "en";
            } else if (
              res.data.data.id == 3 ||
              res.data.data.name_en == "zh_cn"
            ) {
              this.$i18n.locale = "zh";
              sessionStorage.setItem("locale", "zh");
              this.changeLocale = "zh_cn";
            }
            this.changeLang();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    //后台语言接口
    changeLang() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/changeLocale/" + this.changeLocale
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #000;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #ffb20d;
}
.home {
  width: 100%;
  height: 100vh;
  background-color: #fff;
}
.numArea {
  width: 100%;
  height: 160px;
}
.numItem {
  width: 20%;
  height: 35px;
  outline: 1px solid #ccc;
  float: left;
  margin-left: 4%;
  line-height: 35px;
  text-align: center;
  margin-top: 15px;
}
.actNum {
  color: white;
  outline: 1px solid #2f75f4;
  background-color: #2f75f4;
}
@media screen and (min-width: 800px) {
  .numInput {
    width: 800px;
  }
}
@media screen and (max-width: 800px) {
  .numInput {
    width: 100%;
  }
}
.numInput {
  position: fixed;
  bottom: 50px;
  height: 50px;
  border-bottom: 1px solid #f3f3f3;
  border-top: 1px solid #f3f3f3;
}
.nomBtn {
  height: 36px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 36px;
  width: 800px;
  background: #000;
  color: #fff;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/MealNum.vue